// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html.has-footer{padding-bottom:80px}html.has-footer .container{padding-bottom:0;min-height:calc(100vh - 170px)}", ""]);
// Exports
module.exports = exports;
